import Vue from 'vue';
import Component from 'vue-class-component';
import {
  toolIcons,
  toolRanges,
  WHITEBOARD_COLORS,
  COLOR_PICKER_ID,
  ToolIconType,
  ToolRangeType
} from '@/values/ed-whiteboard.values';
import { SINGLE_BOARD_TYPES } from '../values/ed-transparency-meeting.values';
import {ED_CONTEXT_MENU_EVENTS} from '@/plugins/ed-context-menu/ed-context-menu.values';
import {CLOSE_NAV_MEETING_TOOLS_EVENT} from '@/content/values/ed-presentation-mode.values';
import {MEETING_TYPES_IDS} from '@/meetings/values/meetings.values';

@Component({})
export default class WhiteboardMenuMixin extends Vue {

  public toolIcons            : ToolIconType = toolIcons();
  public toolRanges           : ToolRangeType = toolRanges();
  public toolColors           : any = WHITEBOARD_COLORS;
  public showToolColors       : boolean = false;
  public toolbarColorSelected : string = COLOR_PICKER_ID;
  public toolbarSelected      : string = 'move';
  public showColorPicker      : boolean = false;
  public specificColor        : any = () => {};
  public toolRefIdSelected    : string = this.toolIcons.move.options.hand.refId;
  public isPreviousDisconnected : boolean = false;

  get isPresentationStudentMode() : boolean {
    return this.$store.state.CourseStore.isPresentationStudentMode;
  }

  get currentBoardUserId() : number {
    return this.$store.state.MeetingsStore.currentBoardUser.id;
  }

  get userLoginId() : number {
    return this.$store.state.AuthStore.user.id;
  }

  get isBoardSectionHomework() : boolean {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

  get isShowHand() : boolean {
    return (this.isPresentationStudentMode && this.isBoardSectionHomework) || !this.isPresentationStudentMode;
  }

  get currentMeetingData() {
    return this.$store.state.MeetingsStore.currentMeetingData;
  }

  get isWhiteBoard(): boolean {
    return this.currentMeetingData.meetingType === MEETING_TYPES_IDS.WHITEBOARD
  }

  get isPageBasedType(): boolean {
    const viewerType = this.$store.state.MeetingsStore.presentationModeViewerType;
    return !(SINGLE_BOARD_TYPES.includes(viewerType) || this.isWhiteBoard);
  }

  get offlineMode() : boolean {
    return this.$store.state.AppStore.offlineMode;
  }

  public defineColor() : void {
    this.showColorPicker = !this.showColorPicker;
    if(this.showColorPicker){
      this.specificColor.hex = this.toolColors[this.toolbarColorSelected];
      this.toolbarColorSelected = COLOR_PICKER_ID;
    }
  }

  public setMenuOptions(options: any): Array<any> {
    let menuOptions = [];
    for (const tool in options) {
      if(options[tool].condition && this[options[tool].condition] !== options[tool].conditionValue){
        continue;
      }
      let menu = { 
        borderBottom:true,
        icon: options[tool].icon,
        code: options[tool].refId,
        type: options[tool].name,
        color: 'gray',
        title:options[tool].i18n,
        id: options[tool].id,
        isSecondary: options[tool].isSecondary
      };
      menuOptions.push(menu);
    }
    return menuOptions;
  }

  public closeColorPicker(): void {
    if (this.showColorPicker) {
      this.showColorPicker = false;
    }
  }

  public setCloseColorPicker(path: Array<HTMLElement>) {
    let found: boolean;
    found = path.some((el: HTMLElement) => el.id == 'wb-color-picker-library-id'
        || el.id == 'wb-color-picker-id');
    if (!found) this.closeColorPicker();

  }

  public setCloseDropDowns(path: Array<HTMLElement>) {
    let found: boolean;

    found = path.some((el: HTMLElement) => (el.id == 'tool-icons-drop-down-id'
        || el.id == 'add-pages-id' || el.id == 'app'));
    if (!found) this.closeEdContextMenu();
  }

  public closeEdContextMenu() {
    this.$EdContextMenu.$emit(ED_CONTEXT_MENU_EVENTS.CLOSE_CONTEXT_MENU, {discartAction: true});
    this.$edEventBus.$emit(CLOSE_NAV_MEETING_TOOLS_EVENT);
  }


  public setCloseDeployedItems(event: any) {
    let path: Array<HTMLElement> = event.path || (event.composedPath && event.composedPath());
    this.setCloseColorPicker(path)
    this.setCloseDropDowns(path);
  }



}